import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center text-center px-6"
          style={{ backgroundColor: "#1C1C1E" }}
        >
          <p className="font-display text-3xl mb-4" style={{ color: "#F4EAD4" }}>
            Une petite turbulence d'énergie
          </p>
          <p className="font-body text-sm mb-8 max-w-md" style={{ color: "#A2A2A6" }}>
            Quelque chose s'est interrompu. Reviens à l'accueil et réessaye, tout est en sécurité.
          </p>
          <button
            data-testid="error-reset-button"
            onClick={this.handleReset}
            style={{ backgroundColor: "#C5A059", color: "#1C1C1E" }}
            className="tracking-[0.15em] uppercase rounded-sm px-7 py-3.5 font-body text-sm"
          >
            Revenir à l'accueil
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
